import { ThemeProvider } from "@zendeskgarden/react-theming";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Footer from "./components/footer";
import Header from "./components/header";
import Main from "./components/main";
import Navbar from "./components/navbar";
import {
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  SIGNUP_ROUTE,
  SIGNUP_SUCCESS_ROUTE,
  SHORTLIST_BASE_ROUTE,
} from "./providers/routes";
import { AuthenticationService } from './services/auth.service';
import ReactGA from "react-ga4";
import {iniciarControleSessao } from "./services/session.service";
import {iniciarControleAbas } from "./services/session-abas.service";
// import { HelmetProvider } from "react-helmet-async";
// import BannerCookie from "./components/banner-cookie";

class App extends React.Component<any> {

    
async componentDidMount() {
  iniciarControleAbas();
  iniciarControleSessao();
  AuthenticationService.isRh()
    ? this.reactGARecruitment(process.env.REACT_APP_GOOGLE_ANALYTICS_RECRUITMENT)
    : this.reactGAUser(process.env.REACT_APP_GOOGLE_ANALYTICS_PROFESSIONAL);
}

  async componentDidUpdate(prevProps: any) {
    if (AuthenticationService.isRh() !== undefined) {
      AuthenticationService.isRh() ? this.reactGARecruitment(process.env.REACT_APP_GOOGLE_ANALYTICS_RECRUITMENT) : this.reactGAUser(process.env.REACT_APP_GOOGLE_ANALYTICS_PROFESSIONAL);
    }

    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      this.setState({
        currentLanguage: this.props.currentLanguage,
      });
    }
  }

  reactGARecruitment = (key: any) => {
    ReactGA.initialize(`${key}`);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

  reactGAUser = (key: any) => {
    ReactGA.initialize(`${key}`);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

  render() {
    //Declarar rotas em que o Header, Navbar ou Footer não aparecerão.
    const hideRoutes: string[] = [
      LOGIN_ROUTE,
      SIGNUP_ROUTE,
      SIGNUP_SUCCESS_ROUTE,
      FORGOT_PASSWORD_ROUTE,
      SIGNUP_SUCCESS_ROUTE,
      SHORTLIST_BASE_ROUTE,
    ];

    const getPathnameWithoutToken = ({ pathname }: { pathname: string }) => {
      const path = pathname.split('/').splice(1,1);
      let pathWithoutToken = path[0] === 'shortlist' ? '/shortlist' : pathname;
      
      if (pathWithoutToken === '/') {
        pathWithoutToken = '/home';
      };

      return pathWithoutToken;
    }
   
    return (
      <ThemeProvider>
        {/* <HelmetProvider> */}
        {
          !hideRoutes.some(
            (route: string) => route.startsWith(
              getPathnameWithoutToken(this.props.location)
            )
          ) && <Header />
        }
        {
          !hideRoutes.some(
            (route: string) => route.startsWith(
              getPathnameWithoutToken(this.props.location)
            )
          ) && <Navbar />
        }
        <Main />
        {/* <BannerCookie /> */}
        {
          !hideRoutes.some(
            (route: string) => route.startsWith(getPathnameWithoutToken(
              this.props.location)
            )
          ) && <Footer />
        }
        {/* </HelmetProvider> */}
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (store: any) => ({
  filter: store.changeLanguageReducer.currentLanguage,
});

export default connect(mapStateToProps)(withRouter(App));
